import React from 'react';
import moment from 'moment';
import NoDataMsg from 'library/noData';

const Body = (props) => (

    <div>
        {
            !props.inventoryAge || props.inventoryAge.length == 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                //If there's DATA
                <div>
                    <div className="row m-0">
                        <div className="text-center list_header">
                            {props.beginDate ?
                                <p><i>From</i> <b>{moment(props.beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                    {props.endDate ? <b>{moment(props.endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                : ""}
                        </div>
                    </div>
                    <div className="table-responsive">
                        {
                            props.inventoryAge.map((item, index) => {
                                return (
                                    <div className="row m-0 mb-2  text-center" style={{ borderStyle: 'Solid', borderBottomWidth: '1px', borderTopWidth: '0px', borderLeftmWidth: '0px', borderRightWidth: '0px' }} key={index} >
                                        <div className="row m-0 mb-2">
                                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 text-center">
                                                <label>Product Name</label>
                                                <h3 className="m-0 grey-text">{item.productName}</h3>
                                                <label>SKU</label>
                                                <h3 className="m-0 grey-text">{item.sku}</h3>
                                            </div>
                                            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 text-center">
                                                <label>Brand</label>
                                                <h3 className="m-0 grey-text">{item.brandName}</h3>
                                                <label>Category</label>
                                                <h3 className="m-0 grey-text">{item.categoryName}</h3>
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 text-center">
                                                <label>Quantity On Hand</label>
                                                <h3 className="m-0 grey-text">{item.quantityOnHand} Units</h3>
                                                <label>Lot number</label>
                                                <h3 className="m-0 grey-text">{item.packageReference}</h3>
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 text-center">
                                                <label>Inventory Age</label>
                                                <h3 className="m-0 grey-text">{item.daysOnHand} Days</h3>
                                                <label>First Received Date</label>
                                                <h3 className="m-0 grey-text">{moment(item.createdDate).format('YYYY-MM-DD')}</h3>
                                            </div>
                                            {
                                                item.cost > 0 &&
                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 text-center">
                                                    <label>Cost</label>
                                                    <h3 className="m-0 grey-text">{"$" + item.cost}</h3>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                )
                            })}
                    </div>
                </div>
        }
    </div>
);

export default Body;